'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function gpaConfig($stateProvider) {
    'ngInject';

    $stateProvider.state('app.gpa', {
        url: '/gpa',
        views: {
            "main@": {
                component: 'gpa'
            }
        }
    });
}

exports.default = gpaConfig;


// WEBPACK FOOTER //
// ./client/app/components/gpa/gpa.config.js